/**
 * @teivor/shared-utils/api — the typed v4 API client shared by both SPAs.
 *
 * Usage:
 *   // once, at app boot:
 *   configureApi({ onUnauthorized: () => navigate('/iam/sign-in') });
 *   // anywhere:
 *   const me = await api.iam.me();              // typed Principal
 *   const list = await http.get('/api/out/leads', { page: 1 });  // low-level
 *
 * Per-module namespaces hang off `api` (api.iam.*, api.out.*, …). Modules add
 * their namespace file (e.g. ./out.ts) and extend `api` here as they are built —
 * the foundation ships `iam` (auth) only; everything else uses `http` until its
 * namespace lands.
 */
export * from './errors';
export { configureApi, http, withQuery } from './client';
export type { ApiConfig } from './client';
export * from './iam';
export * from './shell';

// Re-export the envelope + pagination contract for module namespaces to build on.
export type { ApiResponse, ApiSuccess, ApiError as ApiErrorEnvelope, PaginationQuery, PaginatedResult } from '@teivor/shared-types';

import { iam } from './iam';
import { shell } from './shell';

/** Per-module API namespaces. Extend as modules land (api.out, api.shell, …). */
export const api = {
  iam,
  shell,
} as const;
